import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { ScalePreview } from '../ScalePreview';
import { useEmailShareTabContext } from '../../context/EmailShareTabContext';
import { CenteredSpinner } from '../CenteredSpinner';
import { Flex } from 'foundations-components/components/Flex';
import { DeviceFrame } from 'foundations-components/transitional/components/DeviceFrame';
import { Box } from 'foundations-components/transitional/components/Box';
import { View } from 'foundations-components/components/View';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledIframe = styled.iframe.withConfig({
  displayName: "EmailPreview__StyledIframe",
  componentId: "xcslm4-0"
})(["border:none;"]);
const EmailPreviewDetails = () => {
  var _selectedToValue$prop, _selectedToValue$prop2;
  const {
    selectedFromValue,
    selectedToValue,
    selectedCcValues,
    subjectValue
  } = useEmailShareTabContext();
  return /*#__PURE__*/_jsxs(View, {
    inlineSize: "100%",
    paddingInline: "400",
    paddingBlock: "200",
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "CommerceToolsUiLib.shareToolModal.emailTab.emailPreview.to",
        options: {
          recipientEmailAddress: (_selectedToValue$prop = selectedToValue === null || selectedToValue === void 0 || (_selectedToValue$prop2 = selectedToValue.properties.email) === null || _selectedToValue$prop2 === void 0 ? void 0 : _selectedToValue$prop2.value) !== null && _selectedToValue$prop !== void 0 ? _selectedToValue$prop : ''
        }
      })
    }), selectedCcValues.length > 0 && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "CommerceToolsUiLib.shareToolModal.emailTab.emailPreview.cc",
        options: {
          ccEmailAddresses: selectedCcValues.map(value => {
            var _value$properties$ema;
            return (_value$properties$ema = value.properties.email) === null || _value$properties$ema === void 0 ? void 0 : _value$properties$ema.value;
          }).join(', ')
        }
      })
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "CommerceToolsUiLib.shareToolModal.emailTab.emailPreview.from",
        options: {
          senderEmailAddress: (selectedFromValue === null || selectedFromValue === void 0 ? void 0 : selectedFromValue.email) || '-------'
        }
      })
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "CommerceToolsUiLib.shareToolModal.emailTab.emailPreview.subject",
        options: {
          emailSubject: subjectValue
        }
      })
    })]
  });
};
const EmailPreviewIframe = () => {
  const {
    emailPreview,
    emailPreviewLoading,
    emailPreviewError
  } = useEmailShareTabContext();
  if (emailPreviewLoading) {
    return /*#__PURE__*/_jsx(CenteredSpinner, {});
  }
  if (emailPreviewError) {
    return /*#__PURE__*/_jsx(Flex, {
      inlineSize: "100%",
      blockSize: "100%",
      alignItems: "center",
      justifyContent: "center",
      paddingInlineStart: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "CommerceToolsUiLib.shareToolModal.emailTab.emailPreview.error"
      })
    });
  }
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized - removing the border is not related to any themes/tokens
    _jsx(StyledIframe, {
      "data-test-id": "email-preview-iframe",
      width: "100%",
      height: "100%",
      srcDoc: emailPreview.html
    })
  );
};
export const EmailPreview = () => {
  return /*#__PURE__*/_jsx(DeviceFrame, {
    blockSize: "100%",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      inlineSize: "100%",
      blockSize: "100%",
      overflow: "hidden",
      children: [/*#__PURE__*/_jsx(EmailPreviewDetails, {}), /*#__PURE__*/_jsx(Box, {
        grow: 1,
        inlineSize: "100%",
        children: /*#__PURE__*/_jsx(ScalePreview, {
          scale: 0.8,
          children: /*#__PURE__*/_jsx(EmailPreviewIframe, {})
        })
      })]
    })
  });
};